import React from 'react';


export const RabbitMQ = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/rabbitmq.png')} />
    )
};
